import "../styles/general.css";
import "../styles/queries.css";
import "../styles/404.css";
import { Link } from "react-router-dom";
import { ReactComponent as Ghost } from "../images/ghost.svg";

function NotFound() {
  return (
    <main className="main">
      <div className="container error-container mt-5">
        <div className="flex">
          <span className="span">4</span>
          <Ghost className="ghost" />
          <span className="span">4</span>
        </div>
        <div className="error-type">Page Not Found</div>
        <div className="error-message">
          We're sorry the page you requested could not be found.
        </div>
        <Link to="/" className="btn btn-outline mt-2">
          Go to Home
        </Link>
      </div>
    </main>
  );
}

export default NotFound;
